module.exports = __webpack_public_path__ + "img/map_achtertuin.2b69ae26.png";